import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../RoutingAuth/auth.service';

@Component({
	selector: 'app-silent-callback',
	template: '',
	
})
export class SilentCallbackComponent implements OnInit {


	constructor(private authService: AuthService) { }

	async ngOnInit() {
		this.authService.silentCallback();
	}
}
